/* assets/free-shipping-drawer-bar.js */
(() => {
  // === AYAR ===
  const THRESHOLD_CENTS = 400000; // ✅ 4.000,00 TL ücretsiz kargo eşiği
  const BAR_ID = "fsd-bar";
  const LANG = "tr-TR";
  const CURRENCY = "TRY";

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(LANG, { style: "currency", currency: CURRENCY }).format((cents || 0) / 100);
    } catch {
      return ((cents || 0) / 100).toFixed(2) + " TL";
    }
  };

  function ensureStyles() {
    if (document.getElementById("fsd-style")) return;
    const style = document.createElement("style");
    style.id = "fsd-style";
    style.textContent = `
      /* ===== Free Shipping Bar (Cart Drawer) ===== */
      .fsd-bar{
        width: 95%;
        box-sizing: border-box;
        padding: 10px 12px;
        margin: 10px 0px 12px 10px;

        border: 1px solid rgba(197, 34, 34, 0.35);
        border-radius: 14px;

        background: linear-gradient(180deg, rgba(48, 32, 42, 0.14), rgba(75, 46, 61, 0.06));
        box-shadow:
          0 0 0 1px rgba(197, 34, 45, 0.1) inset,
          0 8px 22px rgba(197, 34, 48, 0.12);

        display: grid;
        gap: 8px;
        position: relative;
        overflow: hidden;
      }

      /* Hafif "parlama" efekti */
      .fsd-bar::before{
        content:"";
        position:absolute;
        inset:-60% -40%;
        background: radial-gradient(circle at 30% 30%, rgba(255, 121, 244, 0.3), transparent 55%);
        filter: blur(8px);
        opacity: .55;
        animation: fsdGlow 2.6s ease-in-out infinite;
        pointer-events:none;
      }

      @keyframes fsdGlow{
        0%, 100% { opacity: .40; transform: translate3d(0,0,0); }
        50% { opacity: .75; transform: translate3d(2%, -2%, 0); }
      }

      .fsd-bar__title{
        font-size: 14px;
        line-height: 1.25;
        font-weight: 400;
        position: relative;
        z-index: 1;
      }

      .fsd-bar__meta{
        display:flex;
        justify-content:space-between;
        gap:10px;
        font-size: 12px;
        opacity: .9;
        position: relative;
        z-index: 1;
      }

      .fsd-bar__track{
        width:100%;
        height: 10px;
        border-radius: 999px;
        background: rgba(0,0,0,.10);
        overflow:hidden;
        position: relative;
        z-index: 1;
      }

      .fsd-bar__fill{
        height:100%;
        border-radius: 999px;
        background: linear-gradient(90deg, rgba(248, 87, 87, 0.95), rgba(251, 168, 168, 0.95));
        box-shadow: 0 0 12px rgba(198, 16, 16, 0.35);
        transition: width .25s ease;
      }
    `;
    document.head.appendChild(style);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return res.json();
  }

  // --- Drawer detection (görünür cart panel) ---
  const isVisible = (el) => {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    if (r.width < 80 || r.height < 80) return false;
    const cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return false;
    return true;
  };

  function findCartDrawer() {
    const candidates = [
      ...document.querySelectorAll('aside, dialog, [role="dialog"], [aria-modal="true"], .cart-drawer, .drawer')
    ];

    for (const el of candidates) {
      if (!isVisible(el)) continue;

      const hasCheckout =
        !!el.querySelector('a[href^="/checkout"]') ||
        !!el.querySelector('button[name="checkout"]') ||
        !!el.querySelector('[href*="checkout"]');

      const hasCartSignals =
        !!el.querySelector('form[action^="/cart"]') ||
        !!el.querySelector('input[name="updates[]"]') ||
        !!el.querySelector('[data-cart-item]') ||
        !!el.querySelector('[class*="cart" i]');

      if (hasCheckout || hasCartSignals) return el;
    }
    return null;
  }

  // ✅ Barı "Sepet" başlığının HEMEN ALTINA koymak için en doğru container
  function findTopInsertContainer(drawer) {
    // 1) Drawer header’ı yakala (Sepet başlığı burada)
    const header =
      drawer.querySelector(".cart-drawer__header") ||
      drawer.querySelector(".drawer__header") ||
      drawer.querySelector('[data-cart-drawer-header]') ||
      drawer.querySelector('header') ||
      drawer.querySelector('[class*="header" i]');

    // 2) Header’dan sonraki ilk anlamlı blok (ürünler/form alanı) -> bar bunun en üstüne gelecek
    if (header) {
      let next = header.nextElementSibling;

      while (next) {
        const rect = next.getBoundingClientRect();
        const emptyText = (next.textContent || "").trim() === "";
        const tooSmall = rect.height < 10;
        const isDivider = next.tagName === "HR";

        if (!isDivider && !tooSmall && !emptyText) break;
        next = next.nextElementSibling;
      }

      if (next) return next;
    }

    // 3) Fallback: ürün/form container’ları
    return (
      drawer.querySelector('form[action^="/cart"]') ||
      drawer.querySelector('[data-cart-items]') ||
      drawer.querySelector('.cart-items') ||
      drawer.querySelector('.cart-drawer__items') ||
      drawer.querySelector('[class*="cart" i]') ||
      drawer
    );
  }

  function buildBarSkeleton() {
    return `
      <div id="${BAR_ID}" class="fsd-bar" aria-live="polite">
        <div class="fsd-bar__title" data-fsd-title></div>
        <div class="fsd-bar__meta">
          <span data-fsd-progress></span>
          <span data-fsd-left></span>
        </div>
        <div class="fsd-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          <div class="fsd-bar__fill" data-fsd-fill style="width:0%"></div>
        </div>
      </div>
    `;
  }

  function updateBar(el, totalCents) {
    const remaining = Math.max(THRESHOLD_CENTS - totalCents, 0);
    const progress = THRESHOLD_CENTS > 0 ? clamp(Math.floor((totalCents * 100) / THRESHOLD_CENTS), 0, 100) : 0;
    const leftPct = 100 - progress;

    const titleEl = el.querySelector("[data-fsd-title]");
    const progEl = el.querySelector("[data-fsd-progress]");
    const leftEl = el.querySelector("[data-fsd-left]");
    const fillEl = el.querySelector("[data-fsd-fill]");
    const trackEl = el.querySelector(".fsd-bar__track");

    if (totalCents >= THRESHOLD_CENTS) {
      if (titleEl) titleEl.textContent = "🎉 Ücretsiz kargo kazandınız!";
      if (progEl) progEl.textContent = "%100 tamamlandı";
      if (leftEl) leftEl.textContent = "Kalan: %0";
    } else {
      if (titleEl) titleEl.innerHTML = `🚚 Ücretsiz kargo için <strong>${money(remaining)}</strong> daha ekleyin!`;
      if (progEl) progEl.textContent = `%${progress} tamamlandı`;
      if (leftEl) leftEl.textContent = `Kalan: %${leftPct}`;
    }

    if (fillEl) fillEl.style.width = `${progress}%`;
    if (trackEl) trackEl.setAttribute("aria-valuenow", String(progress));
  }

  // --- Scheduler (flicker yok) ---
  let scheduled = false;
  let inFlight = false;

  async function runUpdate() {
    if (inFlight) return;
    inFlight = true;

    try {
      ensureStyles();

      const drawer = findCartDrawer();
      if (!drawer) return;

      const container = findTopInsertContainer(drawer);
      if (!container) return;

      let bar = drawer.querySelector(`#${BAR_ID}`);

      if (!bar) {
        // ✅ ÜSTE: header altındaki ilk bloğun en başına
        container.insertAdjacentHTML("afterbegin", buildBarSkeleton());
        bar = drawer.querySelector(`#${BAR_ID}`);
        if (!bar) return;
      } else {
        // ✅ Yanlış konuma düşerse üste taşı
        if (bar.parentElement !== container || bar !== container.firstElementChild) {
          bar.remove();
          container.insertAdjacentHTML("afterbegin", buildBarSkeleton());
          bar = drawer.querySelector(`#${BAR_ID}`);
          if (!bar) return;
        }
      }

      const cart = await fetchCart();
      updateBar(bar, cart.total_price || 0);
    } catch {
      // sessiz
    } finally {
      inFlight = false;
    }
  }

  function scheduleUpdate(delay = 120) {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      runUpdate();
    }, delay);
  }

  // Cart request yakala
  function hookFetch() {
    const orig = window.fetch;
    window.fetch = async (...args) => {
      const res = await orig(...args);
      try {
        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        if (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update") || url.includes("/cart/clear")) {
          scheduleUpdate(150);
          scheduleUpdate(650);
        }
      } catch {}
      return res;
    };
  }

  // Drawer açılınca yakala
  function observeDrawerAppear() {
    let lastDrawer = null;
    const obs = new MutationObserver(() => {
      const drawer = findCartDrawer();
      if (drawer && drawer !== lastDrawer) {
        lastDrawer = drawer;
        scheduleUpdate(60);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    hookFetch();
    observeDrawerAppear();

    scheduleUpdate(80);
    document.addEventListener("click", () => scheduleUpdate(160));
  });
})();
